export default {
  'directSale.columns.table.tag': 'Etiqueta',
  'directSale.columns.table.company': 'Empresa',
  'directSale.columns.table.code': 'Código',
  'directSale.columns.table.customer': 'Cliente',
  'directSale.columns.table.status': 'Situação',
  'directSale.columns.table.dateOfSale': 'Data da Venda',
  'directSale.columns.table.saleValue': 'Valor da Venda',

  'directSale.situation': 'Situação: ',
  'directSale.OPEN': 'Aberta',
  'directSale.AUTHORIZED': 'Autorizado',
  'directSale.CANCELED': 'Cancelado',

  'directSale.create': 'Nova Venda',
  'directSale.form.company': 'Empresa',
  'directSale.form.saller': 'Vendedor',
  'directSale.form.customer': 'Cliente',
  'directSale.form.dateOfSale': 'Data da Venda',
  'directSale.form.details.saleCode': 'Código da Venda',
  'directSale.form.details.authorizationDate': 'Data de Autorização',
  'directSale.form.details.cancellationDate': 'Data de cancelamento',
  'directSale.form.details.reasonCancellation': 'Motivo do cancelamento',
  'directSale.form.observation': 'Observação',

  'directSale.modal.title': 'Itens da venda',
  'directSale.modal.form.manufacturerCode': 'Cód. Fabricante',
  'directSale.modal.form.internalCode': 'Cód. Interno',
  'directSale.modal.form.barCode': 'Cód. Barras',
  'directSale.modal.form.companyCode': 'Cód. Empresa',
  'directSale.modal.form.description': 'Descrição',
  'directSale.modal.form.manufacturer': 'Fabricante',
  'directSale.modal.form.qty': 'Qtde.',
  'directSale.modal.form.unitaryValue': '(R$) Valor Unitário',
  'directSale.modal.form.discount': '(%) Desconto',
  'directSale.modal.form.discountCost': '(R$) Desconto',
  'directSale.modal.form.amount': 'Valor Total ',
  'directSale.modal.form.open.emptyCompanyAndCustomerError': 'Erro',
  'directSale.modal.form.open.emptyCompanyAndCustomerDescription':
    'Favor selecionar uma Empresa e um Cliente antes de adicionar uma peça!',

  'directSale.transmitModal.title': 'Acessar nota fiscal',
  'directSale.transmitModal.description':
    'Selecione a(s) forma(s) de pagamento para transmitir a Nota Fiscal.',
  'directSale.transmitModal.description.invoiceNumber':
    'Número da nota: {number}',
  'directSale.transmitModal.table.paymentType': 'Tipo de pagamento',
  'directSale.transmitModal.table.value': 'Valor',
  'directSale.transmitModal.table.authorizationNumber': 'Número autorização',
  'directSale.transmitModal.button.addPayment': 'Adicionar Pagamento',
  'directSale.transmitModal.button.transmitInvoice': 'Transmitir nota',

  'directSale.transmitModal.paymentForm.integrationType': 'Tipo de integração',
  'directSale.transmitModal.paymentForm.legalCredentialCard':
    'CNPJ credenciadora do cartão',
  'directSale.transmitModal.paymentForm.cardFlag': 'Bandeira do cartão',

  'directSale.transmitModal.paymentForm.integrationOptions.integrated':
    'Pagamento integrado com o sistema de automação da empresa (Ex: equipamento TEF, Comércio Eletrônico)',
  'directSale.transmitModal.paymentForm.integrationOptions.noIntegrated':
    'Pagamento não integrado com o sistema de automação da empresa (Ex: equipamento POS)',

  'directSale.transmitModal.paymentForm.paymentTypeOptions.money': 'Dinheiro',
  'directSale.transmitModal.paymentForm.paymentTypeOptions.check': 'Cheque',
  'directSale.transmitModal.paymentForm.paymentTypeOptions.creditCard':
    'Cartão de Crédito',
  'directSale.transmitModal.paymentForm.paymentTypeOptions.debitCard':
    'Cartão de Débito',
  'directSale.transmitModal.paymentForm.paymentTypeOptions.storeCredit':
    'Crédito da Loja',
  'directSale.transmitModal.paymentForm.paymentTypeOptions.foodVoucher':
    'Vale Alimentação',
  'directSale.transmitModal.paymentForm.paymentTypeOptions.mealTicket':
    'Vale Refeição',
  'directSale.transmitModal.paymentForm.paymentTypeOptions.giftVoucher':
    'Vale Presente',
  'directSale.transmitModal.paymentForm.paymentTypeOptions.fuelVoucher':
    'Vale Combustível',
  'directSale.transmitModal.paymentForm.paymentTypeOptions.mercantileDuplicate':
    'Duplicata Mercantil',
  'directSale.transmitModal.paymentForm.paymentTypeOptions.bankSlip':
    'Boleto Bancário',
  'directSale.transmitModal.paymentForm.paymentTypeOptions.bankDeposit':
    'Depósito Bancário',
  'directSale.transmitModal.paymentForm.paymentTypeOptions.instantPayment':
    'Pagamento Instantâneo (PIX)',
  'directSale.transmitModal.paymentForm.paymentTypeOptions.bankTransfer':
    'Transferência Bancária, Carteira Digital',
  'directSale.transmitModal.paymentForm.paymentTypeOptions.loyaltyProgram':
    'Programa de Fidelidade, Cashback, Crédito Virtual',
  'directSale.transmitModal.paymentForm.paymentTypeOptions.withoutPay':
    'Sem pagamento',

  'directSale.form.domain.items.parts': 'Peças',
  'directSale.form.domain.button.addPart': 'Adicionar Peça',
  'directSale.form.domain.items.manufacturerCode': 'Cód. Fabricante',
  'directSale.form.domain.items.description': 'Descrição',
  'directSale.form.domain.items.amount': 'Qtd.',
  'directSale.form.domain.items.unitaryValue': 'Valor Unitário',
  'directSale.form.domain.items.discount': 'Desconto (%)',
  'directSale.form.domain.items.discountCost': 'Desconto (R$)',
  'directSale.form.domain.items.totalValue': 'Valor Total',

  'directSale.financial.form.planAccount': 'Plano de Contas',
  'directSale.financial.form.documentType': 'Tipo de Documento',
  'directSale.financial.form.paymentCondition': 'Condição de Pagamento',
  'directSale.financial.form.valueNegotiated': 'Valor a Negociar',
  'directSale.financial.button.negotiateFinancial': 'Negociar Financeiro',
  'directSale.financial.table.generateFinancial': 'Gerar Financeiro',
  'directSale.financial.table.generateOrder': 'Gerar Pedido',
  'directSale.financial.table.description': 'Descrição',
  'directSale.financial.table.documentNumber': 'Nº Documento',
  'directSale.financial.table.documentType': 'Tipo de Documento',
  'directSale.financial.table.dueDate': 'Vencimento',
  'directSale.financial.table.value': 'Valor',
  'directSale.financial.table.increaseAndDecrease': 'Acres./Desc.',
  'directSale.financial.table.tariff': 'Tarifa',
  'directSale.financial.table.realValue': 'Valor Real',

  'directSale.create.notification.success': 'Venda Direta Criada!',
  'directSale.create.notification.successDescription':
    'A Venda Direta foi adicionada corretamente ao sistema!',

  'directSale.notifications.remove.confirm.title':
    'Você deseja realmente excluir essa Venda Direta?',
  'directSale.notifications.remove.confirm.content':
    'Ao remover a Venda Direta, todas as informações serão perdidas permanentemente. Ainda sim deseja continuar?',
  'directSale.notifications.remove.success.title': 'Venda direta removida',
  'directSale.notifications.remove.success.description':
    'A Venda Direta foi removida com sucesso!',
  'directSale.notifications.update.success.title':
    'Venda Direta atualizada com sucesso!',
  'directSale.notifications.update.success.description':
    'As informações da Venda Direta foram atualizadas com sucesso.',

  'directSale.notification.create.item.success.title': 'Sucesso!',
  'directSale.notification.create.item.success.description':
    'Item criado com sucesso!',
  'directSale.notification.update.item.success.title': 'Sucesso!',
  'directSale.notification.update.item.success.description':
    'Item alterado com sucesso!',
  'directSale.notifications.remove.item.confirm.title':
    'Deseja realmente excluir o Item?',
  'directSale.notifications.remove.item.confirm.content':
    'Ao remover o Item da Venda, a recuperação do mesmo não poderá ser feita. Ainda sim deseja coninuar?',
  'directSale.notification.remove.item.success.title': 'Sucesso!',
  'directSale.notification.remove.item.success.description':
    'Item removido com sucesso!',
  'directSale.notification.update.item.success.description':
    'Item alterado com sucesso!',

  'directSale.button.authorizeSale': 'Autorizar Venda',
  'directSale.notifications.authorizeSale.confirm.title':
    'Deseja realmente autorizar a venda?',
  'directSale.notifications.authorizeSale.confirm.content':
    'Ao autorizar a Venda Direta, não terá como reverter a autorização. Ainda sim deseja continuar?',
  'directSale.notifications.authorizeSale.success.title': 'Sucesso!',
  'directSale.notifications.authorizeSale.success.description':
    'Sua venda foi autorizada com sucesso!',

  'directSale.create.items.searchMessage':
    'Filtre e selecione os itens a serem adicionados na Venda Direta.',

  'directSale.button.cancelSale': 'Cancelar Venda',
  'directSale.cancelSale.modal.title.reasonCancellation':
    'Motivo do Cancelamento',
  'directSale.notifications.cancelSale.success.title': 'Sucesso!',
  'directSale.notifications.cancelSale.success.description':
    'Venda cancelada com sucesso!',

  'directSale.button.generateInvoice': 'Gerar Nota Fiscal',
  'directSale.generateInvoice.modal.title.modelInvoice': 'Modelo da nota',
  'directSale.generateInvoice.modal.title.modelInvoiceNfe': 'NF-e modelo 55',
  'directSale.generateInvoice.modal.title.modelInvoiceNfce': 'NFC-e modelo 65',
  'directSale.generateInvoice.modal.create': 'Somente Criar Nota',
  'directSale.generateInvoice.modal.createRedirect':
    'Criar e Redirecionar para a Nota',

  'directSale.generateInvoice.notification.success': 'Sucesso!',
  'directSale.generateInvoice.notification.successDescription':
    'Nota fiscal foi gerada com sucesso pela Venda Direta!',

  'directSale.button.printSale': 'Imprimir Venda',
  'directSale.button.termLgbt': 'Termo LGPD',
};
